<template>
  <div>
    <h2>Poczta</h2>
    <v-btn color="primary" to="/Mails/SendMails"
      >Stwórz nowe maile do wysłania</v-btn
    >
    <v-checkbox
      v-model="enableNotify"
      label="Pokazuj powiadomienia o mailach"
    ></v-checkbox>

    <v-row>
      <v-col>
        <v-btn
          :loading="resendButtonLoading"
          class="mr-2"
          color="success"
          @click="confirmResendNotSendedDialog = true"
          >Wyślij ponownie wszystkie niewysłane maile</v-btn
        >
        <v-btn
          :loading="resendButtonLoading"
          class="mr-2"
          color="primary"
          @click="$refs.dataTable.searchUp('Rejected')"
          >Pokaż niewysłane</v-btn
        >
      </v-col>
    </v-row>
    <data-table
      ref="dataTable"
      :headers="allHeaders"
      @click:row="clickRow"
      serverPagination
      endpoint="Mail/GetMailsWithoutContent"
      @itemsLoaded="itemsLoaded"
      disableFilters
      disableSort
    >
      <template v-slot:item.status="{ item }">
        <v-chip v-if="item.status === 0 || item.status === 1" color="primary"
          >W kolejce</v-chip
        >
        <v-chip v-if="item.status === 2" color="success">Wysłano</v-chip>
        <v-chip v-if="item.status === 3" color="error">Nie wysłano</v-chip>
      </template>
      <template v-slot:item.createDateTime="{ item }">{{
        moment(item.createDateTime).format("YYYY-MM-DD HH:mm:ss")
      }}</template>
    </data-table>
    <v-dialog v-model="mailInfoDialog" scrollable width="1200">
      <v-card v-if="selectedMail">
        <v-card-title>
          Mail
          <v-spacer></v-spacer>
          <v-btn icon @click="mailInfoDialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>Data utworzenia: {{ selectedMail.createDateTime }}</v-col>
          </v-row>
          <v-row>
            <v-col>Od: {{ selectedMail.from }}</v-col>
            <v-col>Do: {{ selectedMail.address }}</v-col>
          </v-row>
          <v-row>
            <v-col>Tytuł: {{ selectedMail.title }}</v-col>
          </v-row>
          <v-row>
            <v-col>
              Status:
              <v-chip v-if="selectedMail.status === 2" color="success"
                >Wysłano</v-chip
              >
              <v-chip v-if="selectedMail.status === 3" color="error"
                >Nie wysłano</v-chip
              >
              <v-chip
                v-if="selectedMail.status === 0 || selectedMail.status === 1"
                color="primary"
                >W kolejce</v-chip
              >
            </v-col>
            <v-col>Data wysłania: {{ selectedMail.lastSendDateTime }}</v-col>
          </v-row>
          <v-row v-if="selectedMail.status === 3">
            <v-col>
              Powód nie wysłania:
              <br />
              {{ selectedMail.failReason }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="mail-content" v-html="selectedMail.body"></div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-btn
                v-if="selectedMail.status !== 0 && selectedMail.status !== 1"
                :loading="resendButtonLoading"
                color="primary"
                @click="resendMail"
                >Dodaj ponownie do kolejki</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmResendNotSendedDialog" scrollable width="800">
      <v-card>
        <v-card-title>Ponowne wysyłanie maili</v-card-title>
        <v-card-text>Czy na pewno chcesz wysłać ponownie maile?</v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-btn
                block
                color="success"
                :loading="resendButtonLoading"
                @click="confirmResendUnsendedMails"
                >Wyślij</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                block
                color="error"
                :loading="resendButtonLoading"
                @click="confirmResendNotSendedDialog = false"
                >Anuluj</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { notify, showError, showInfo, showSuccess } from "@/helpers";
const signalR = require("@microsoft/signalr");
export default {
  data() {
    return {
      itemsPerPage: 0,
      enableNotify: true,
      search: "",
      mails: [],
      mailInfoDialog: false,
      confirmResendNotSendedDialog: false,
      selectedMail: null,
      resendButtonLoading: false,
      waitingHeaders: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Data utworzenia",
          value: "createDateTime",
        },
        {
          text: "Do",
          value: "address",
        },
        {
          text: "Od",
          value: "from",
        },
        {
          text: "Tytuł",
          value: "title",
        },
      ],
      sentHeaders: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Data utworzenia",
          value: "createDateTime",
        },
        {
          text: "Do",
          value: "address",
        },
        {
          text: "Od",
          value: "from",
        },
        {
          text: "Tytuł",
          value: "title",
        },
        {
          text: "Wysłano",
          value: "lastSendDateTime",
        },
      ],
      rejectedHeaders: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Data utworzenia",
          value: "createDateTime",
        },
        {
          text: "Do",
          value: "address",
        },
        {
          text: "Od",
          value: "from",
        },
        {
          text: "Tytuł",
          value: "title",
        },
        {
          text: "Powód",
          value: "failReason",
        },
      ],
      allHeaders: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Data utworzenia",
          value: "createDateTime",
        },
        {
          text: "Do",
          value: "address",
        },
        {
          text: "Od",
          value: "from",
        },
        {
          text: "Tytuł",
          value: "title",
        },
        {
          text: "Status",
          value: "status",
        },
      ],
      connection: null,
      resendButtonLoading: false,
    };
  },
  watch: {
    "connection.connectionState": function (newVal) {
      if (newVal.toLowerCase() === "connected") {
        this.connection.invoke("SubscribeEmail");
      }
    },
  },
  methods: {
    itemsLoaded(items) {
      this.mails = items;
    },
    confirmResendUnsendedMails() {
      let vm = this;
      vm.resendButtonLoading = true;
      vm.$http.get("Mail/RequeueAllNotSendMails").finally(() => {
        vm.resendButtonLoading = false;
        vm.confirmResendDialog = false;
      });
    },
    resendMail() {
      let vm = this;
      vm.resendButtonLoading = true;
      vm.$http.get("Mail/ResendMail?id=" + vm.selectedMail.id).finally(() => {
        vm.resendButtonLoading = false;
      });
    },
    async clickRow(item) {
      this.selectedMail = item;
      this.selectedMail = (
        await this.$http.get("Mail/GetMailDetails?id=" + this.selectedMail.id)
      ).data;
      this.mailInfoDialog = true;
    },
    cutStringTo(item, maxLength = 30) {
      let value = item.toString().substring(0, maxLength);
      if (item.length > maxLength) {
        value += "...";
      }
      return value;
    },
    checkChanges(oldList, newList) {
      newList.forEach((newMail) => {
        if (this.selectedMail && this.selectedMail.id === newMail.id) {
          this.selectedMail = newMail;
        }
        let oldMail = oldList.find((el) => el.id === newMail.id);
        if (!oldMail) {
          showInfo(
            "Wygenerowano nowy mail\n",
            "Adresat: " + newMail.address + "\nTytuł: " + newMail.title
          );

          oldList.pop();
          oldList.unshift(newMail);
        } else {
          if (newMail.status === oldMail.status) {
            return;
          }
          if (this.enableNotify) {
            if (newMail.status === 2) {
              showSuccess(
                "Wysłano mail",
                "Adresat: " + newMail.address + "\nTytuł: " + newMail.title
              );
            }
            if (newMail.status === 3) {
              showError(
                "Problem z wysłaniem mail'a",
                "Id: " +
                  newMail.id +
                  "\nAdresat: " +
                  newMail.address +
                  "\nTytuł: " +
                  newMail.title
              );
            }
          }
          oldMail.status = newMail.status;
        }
      });
    },
    signalRConnect() {
      let vm = this;
      vm.connection = new signalR.HubConnectionBuilder()
        .withUrl(document.baseAPIurl + "hubs/portalHub", {
          accessTokenFactory: () => localStorage.getItem("token"),
        })
        .withAutomaticReconnect()
        .build();

      vm.connection.on("UpdateMails", (data) => {
        if (vm.enableNotify) {
          vm.checkChanges(vm.mails, data);
        }
      });
      vm.connection.onreconnected = () => {
        console.log("reconnect");
      };
      vm.connection.start();
    },
  },
  mounted() {
    this.signalRConnect();
  },
  beforeDestroy() {
    this.connection?.stop();
  },
};
</script>

<style scoped>
.mail-content {
  border: 1px solid black;
  padding: 15px;
  box-shadow: 0 0 5px black;
  max-width: 1150px;
  max-height: 600px;
  overflow: scroll;
  color: black;
  background: white;
}
</style>
